import {z} from 'zod';

export const envNameSchema = z.union([
  z.literal(`dev`),
  z.literal(`sit`),
  z.literal(`stage`),
  z.literal(`prod`),
]);
export const previewSchema = z
  .union([z.literal(`true`), z.literal(`false`)])
  .transform((value) => value === `true`);

export const languageSchema = z.union([
  z.literal(`bg`), // Bulgarian
  z.literal(`cs`), // Czech
  z.literal(`da`), // Danish
  z.literal(`de`), // German
  z.literal(`el`), // Greek
  z.literal(`en`), // English
  z.literal(`es`), // Spanish
  z.literal(`et`), // Estonian
  z.literal(`fi`), // Finnish
  z.literal(`fr`), // French
  z.literal(`hr`), // Croatian
  z.literal(`hu`), // Hungarian
  z.literal(`is`), // Icelandic
  z.literal(`it`), // Italian
  z.literal(`lt`), // Lithuanian
  z.literal(`lv`), // Latvian
  z.literal(`mt`), // Maltese
  z.literal(`nl`), // Dutch
  z.literal(`pl`), // Polish
  z.literal(`pt`), // Portuguese
  z.literal(`ro`), // Romanian
  z.literal(`sk`), // Slovak
  z.literal(`sl`), // Slovenian
  z.literal(`sv`), // Swedish
]);

export const marketIdSchema = z.union([
  z.literal(`at`), // Austria
  z.literal(`be`), // Belgium
  z.literal(`bg`), // Bulgaria
  z.literal(`ch`), // Switzerland
  z.literal(`cy`), // Cyprus
  z.literal(`cz`), // Czech Republic
  z.literal(`de`), // Germany
  z.literal(`dk`), // Denmark
  z.literal(`ee`), // Estonia
  z.literal(`es`), // Spain
  z.literal(`fi`), // Finland
  z.literal(`fr`), // France
  z.literal(`gb`), // UK
  z.literal(`gr`), // Greece
  z.literal(`hr`), // Croatia
  z.literal(`hu`), // Hungary
  z.literal(`ie`), // Ireland
  z.literal(`is`), // Iceland
  z.literal(`it`), // Italy
  z.literal(`li`), // Liechtenstein
  z.literal(`lt`), // Lithuania
  z.literal(`lu`), // Luxembourg
  z.literal(`lv`), // Latvia
  z.literal(`mt`), // Malta
  z.literal(`nl`), // Netherlands
  z.literal(`pl`), // Poland
  z.literal(`pt`), // Portugal
  z.literal(`ro`), // Romania
  z.literal(`se`), // Sweden
  z.literal(`si`), // Slovenia
  z.literal(`sk`), // Slovakia
  z.literal(`sb`),
  z.literal(`fm`),
]);

export const languageTagSchema = z.union([
  z.literal(`de-AT`), // Austria
  z.literal(`nl-BE`), // Belgium (Dutch in Belgium)
  z.literal(`fr-BE`), // Belgium (French in Belgium)
  z.literal(`bg-BG`), // Bulgaria
  z.literal(`de-CH`), // Switzerland (German in Switzerland)
  z.literal(`fr-CH`), // Switzerland (French in Switzerland)
  z.literal(`it-CH`), // Switzerland (Italian in Switzerland)
  z.literal(`el-CY`), // Cyprus (Greek in Cyprus)
  z.literal(`cs-CZ`), // Czech Republic
  z.literal(`de-DE`), // Germany
  z.literal(`da-DK`), // Denmark
  z.literal(`et-EE`), // Estonia
  z.literal(`es-ES`), // Spain
  z.literal(`fi-FI`), // Finland
  z.literal(`fr-FR`), // France
  z.literal(`en-GB`), // United Kingdom
  z.literal(`el-GR`), // Greece
  z.literal(`hr-HR`), // Croatia
  z.literal(`hu-HU`), // Hungary
  z.literal(`en-IE`), // Ireland
  z.literal(`is-IS`), // Iceland
  z.literal(`it-IT`), // Italy
  z.literal(`de-LI`), // Liechtenstein
  z.literal(`lt-LT`), // Lithuania
  z.literal(`fr-LU`), // Luxembourg (French in Luxembourg)
  z.literal(`de-LU`), // Luxembourg (German in Luxembourg)
  z.literal(`lv-LV`), // Latvia
  z.literal(`mt-MT`), // Malta
  z.literal(`nl-NL`), // Netherlands
  z.literal(`pl-PL`), // Poland
  z.literal(`pt-PT`), // Portugal
  z.literal(`ro-RO`), // Romania
  z.literal(`sv-SE`), // Sweden
  z.literal(`sl-SI`), // Slovenia
  z.literal(`sk-SK`), // Slovakia
]);

const headerSchema = z.object({
  headerName: z.string(),
  headerValue: z.string(),
});
export const rotatingVerifySecretSchema = z
  .union([headerSchema, z.string().refine((value) => value.includes(`:`))])
  .transform((value, ctx) => {
    if (typeof value === `object`) {
      return value;
    } else {
      const [headerName, headerValue] = value.split(`:`);
      if (!headerName || !headerValue) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Input was incorrect`,
        });
        return z.NEVER;
      }
      return {headerName, headerValue};
    }
  });
